export const environment = {
  production: true,
  apiUrl: 'https://api.clubfitness.tn/api',
  filesUrl: 'https://api.clubfitness.tn/',
}
